import type { IconDefinition } from '../index.tsx';

export const iconArcade: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconArcade',
  icon: [
    16,
    16,
    [],
    '',
    'M8.46219 7.25411L10.2 0L2.66671 10.43641L8.30738 8.9183L6.8916 16L13.33337 5.9657L8.46219 7.25411Z',
  ],
};
